// src/OnlineGame/CharacterSelectScene.js
import Phaser from "phaser";

export default class CharacterSelectScene extends Phaser.Scene {
  constructor() {
    super({ key: "CharacterSelectScene" });
  }

  preload() {
    // Preload the idle spritesheets for each class so that previews display quickly.
    const classes = ["archer", "knight", "orc", "priest", "swordsman", "wizard"];
    classes.forEach(cls => {
      this.load.spritesheet(
        `${cls}-idle`,
        `/assets/chars/${cls}/${cls}-Idle.png`,
        { frameWidth: 100, frameHeight: 100 }
      );
    });
  }

  create() {
    // Title for the select screen.
    this.add.text(400, 50, "Select Your Character", {
      font: "32px monospace",
      fill: "#ffffff"
    }).setOrigin(0.5);

    // Retrieve saved characters from localStorage.
    let savedChars = JSON.parse(localStorage.getItem("savedCharacters")) || [];
    // Ensure we always have 3 slots.
    const slots = [0, 1, 2];

    slots.forEach((slotIndex, i) => {
      const slotX = 200 + i * 200;
      const slotY = 300;

      // Draw a rectangle for the slot.
      const slotBg = this.add.rectangle(slotX, slotY, 150, 200, 0x222222, 0.8)
        .setOrigin(0.5);
      slotBg.setStrokeStyle(2, 0xffffff);

      if (savedChars[slotIndex]) {
        const charData = savedChars[slotIndex];
        // Display the character's Game ID and Class.
        this.add.text(slotX, slotY - 70, charData.gameId, {
          font: "20px monospace",
          fill: "#ffff00"
        }).setOrigin(0.5);
        this.add.text(slotX, slotY - 40, charData.chosenClass.toUpperCase(), {
          font: "20px monospace",
          fill: "#ffffff"
        }).setOrigin(0.5);
        // Display a preview using the idle spritesheet.
        // Ensure the animation exists.
        const animKey = `${charData.chosenClass}-idle-anim`;
        if (!this.anims.exists(animKey)) {
          this.anims.create({
            key: animKey,
            frames: this.anims.generateFrameNumbers(`${charData.chosenClass}-idle`, { start: 0, end: 5 }),
            frameRate: 6,
            repeat: -1
          });
        }
        const preview = this.add.sprite(slotX, slotY + 20, `${charData.chosenClass}-idle`)
          .setScale(4);
        preview.play(animKey);

        // Make the slot clickable to play this character.
        slotBg.setInteractive({ useHandCursor: true });
        slotBg.on("pointerdown", () => {
          console.log("Playing saved character:", charData);
          this.scene.start("PhaserMMO", {
            chosenClass: charData.chosenClass,
            gameId: charData.gameId,
            attributes: charData.attributes
          });
        });
      } else {
        // Slot is empty.
        this.add.text(slotX, slotY, "Empty Slot", {
          font: "20px monospace",
          fill: "#ff0000"
        }).setOrigin(0.5);

        // Make empty slot clickable to create a new character.
        slotBg.setInteractive({ useHandCursor: true });
        slotBg.on("pointerdown", () => {
          console.log("Creating new character in slot", slotIndex);
          // Optionally, you can pass slotIndex to the creation scene to know where to save.
          this.scene.start("CharacterCreationScene", { slotIndex: slotIndex });
        });
      }
    });

    // "Back" button (if needed) to return to TitleScene.
    const backButton = this.add.text(400, 550, "Back", {
      font: "28px monospace",
      fill: "#00ff00",
      backgroundColor: "#000000",
      padding: { x: 10, y: 5 }
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    backButton.on("pointerdown", () => {
      this.scene.start("TitleScene");
    });
  }
}
